import { useState, useCallback } from 'react';

import { gql, useMutation } from '@zenbusiness/application-commons-graphql';

const GENERATE_BUSINESS_NAME = gql`
  mutation GenerateBusinessName($identity: VisitorIdentity!, $input: GenerateBusinessNameInput!) {
    generateBusinessName(identity: $identity, input: $input) {
      id
      type
      attributes {
        role
        messageType
        uiInstructions {
          componentType
          props
        }
      }
      meta {
        renderStrategy
      }
    }
  }
`;

export function useBusinessName() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [businessName, setBusinessName] = useState(null);

  const [generateBusinessNameMutation] = useMutation(GENERATE_BUSINESS_NAME);

  const generateBusinessName = useCallback(
    async (visitUuid, userOptions) => {
      try {
        setLoading(true);
        setError(null);
        const result = await generateBusinessNameMutation({
          variables: {
            identity: {
              visitUuid
            },
            input: {
              userOptions
            }
          }
        });
        setLoading(false);
        setBusinessName(result.data?.generateBusinessName);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    },
    [generateBusinessNameMutation]
  );

  return {
    loading,
    error,
    businessName,
    generateBusinessName
  };
}
